(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.HeaderView = (function(superClass) {
    extend(HeaderView, superClass);

    function HeaderView() {
      return HeaderView.__super__.constructor.apply(this, arguments);
    }

    HeaderView.prototype.events = {
      "click .search-toggle-button": "toggleSearch",
      "change .shop-by-category, .shop-by-vendor": "fireSearchSelect",
      "click .main-nav .dropdown > a": "toggleMenu",
      "click .main-nav .dropdown.mega": "positionMegaNav",
      "click .main-nav .dropdown.mega li[data-expandable='true']": "determineNavAction",
      "click .mobile-nav-dropdown-container .dropdown > a": "toggleMobileNavTier",
      "click .sub-nav li[data-expandable='true'] > a": "toggleMobileMegaNavTier",
      "click .mobile-nav-item.navigate > a": "toggleMobileNav",
      "click .mobile-nav-item.browse > a": "toggleMobileNav"
    };

    HeaderView.prototype.initialize = function() {
      this.body = $(document.body);
      this.headerNav = this.$(".header-nav");
      if (this.$(".mega.dropdown")) {
        this.megaDropdown = this.$(".mega .dropdown-nav");
        this.megaDropdownHeader = this.$(".mega.dropdown .dropdown-nav header");
        this.primaryPanel = this.$(".primary-nav-level");
        this.secondaryPanel = this.$(".secondary-nav-level");
        this.tertiaryPanel = this.$(".tertiary-nav-level");
        this.allPanels = this.primaryPanel.add(this.secondaryPanel).add(this.tertiaryPanel).add(this.$(".brands-nav-level"));
        this.subNavContents = this.primaryPanel.html();
        this.browseSearchPopup = this.$(".search-browse-container");
      }
      this.initializeNav();
      this.adjustSimpleNavPosition();
      $(window).resize((function(_this) {
        return function() {
          if (document.documentElement.offsetWidth >= 768 && _this.headerNav.hasClass("mobile-nav")) {
            _this.headerNav.addClass("main-nav").removeClass("mobile-nav");
            return _this.setupDesktopNav();
          } else if (document.documentElement.offsetWidth < 768 && _this.headerNav.hasClass("main-nav")) {
            _this.headerNav.addClass("mobile-nav").removeClass("main-nav");
            return _this.setupMobileNav();
          }
        };
      })(this)).trigger("resize");
      $(document.body).on("click", (function(_this) {
        return function(e) {
          if (!_this.$(e.target).closest(".search-toggle-button").length) {
            return _this.$(".search-toggle-button").removeClass("open");
          }
        };
      })(this));
      return this.transitionend = (function(transition) {
        var transEndEventNames;
        transEndEventNames = {
          "-webkit-transition": "webkitTransitionEnd",
          "-moz-transition": "transitionend",
          transition: "transitionend"
        };
        return transEndEventNames[transition];
      })(Modernizr.prefixed("transition"));
    };

    HeaderView.prototype.initializeNav = function() {
      var i, len, panel, ref, results;
      this.$(".secondary-list").appendTo(this.secondaryPanel);
      this.$(".tertiary-list").appendTo(this.tertiaryPanel);
      ref = this.allPanels.find("ul");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        panel = ref[i];
        panel = $(panel);
        if (panel.find("li").length > 5) {
          results.push(panel.find("li:last-child a").css("border-bottom", "0px"));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    HeaderView.prototype.setupDesktopNav = function() {
      this.headerNav.append($(".nav-item"));
      this.browseSearchPopup.removeClass("mobile").appendTo(this.$(".search-browse-parent-outline"));
      this.$(".sub-nav").remove();
      this.$(".dropdown > a > .arrow").removeClass("mobile").html("[");
      return this.initializeNav();
    };

    HeaderView.prototype.setupMobileNav = function() {
      var browseButton, megaNavItem, mobileBrowseContainer, mobileNavDropdownContainer, mobileNavItems, navigateButton;
      mobileBrowseContainer = this.$(".mobile-browse-container");
      mobileNavDropdownContainer = this.$(".mobile-nav-dropdown-container");
      mobileNavItems = this.$(".mobile-nav-item");
      browseButton = mobileNavItems.filter(".browse");
      navigateButton = mobileNavItems.filter(".navigate");
      megaNavItem = this.$(".dropdown.mega");
      mobileBrowseContainer.append(this.browseSearchPopup);
      this.browseSearchPopup.addClass("mobile");
      mobileNavDropdownContainer.append($("<ul class='dropdown-nav dropdown-nav-mega'>").append($(".nav-item")));
      if (this.$(".primary-nav-level li[data-expandable]").length) {
        mobileNavDropdownContainer.find(".nav-item.mega").after($("<li class='sub-nav'>").append(this.subNavContents));
      }
      return this.$(".dropdown > a > .arrow").add(".sub-nav .arrow").addClass("mobile").html("]");
    };

    HeaderView.prototype.toggleSearch = function(e) {
      if (this.$(".search-toggle-button").hasClass("open") && this.$(e.target).hasClass("search-browse-parent-outline")) {
        return this.$(".search-toggle-button").removeClass("open");
      } else {
        this.$(".search-browse-container").css({
          top: $(".search-browse-parent-outline").height()
        });
        return this.$(".search-toggle-button").addClass("open");
      }
    };

    HeaderView.prototype.fireSearchSelect = function(e) {
      var target;
      target = this.$(e.target);
      if (target.val().length) {
        return window.location = target.val();
      }
    };

    HeaderView.prototype.toggleMenu = function(e) {
      var dropdown;
      e.preventDefault();
      dropdown = this.$(e.target).closest(".dropdown");
      if (!this.$(e.target).closest(".dropdown-nav").length) {
        this.$(".dropdown").not(dropdown).removeClass("active");
        return dropdown.toggleClass("active");
      }
    };

    HeaderView.prototype.adjustSimpleNavPosition = function() {
      var dropdown, dropdownWidth, i, leftPosition, len, navWidth, ref, results;
      navWidth = this.headerNav.width();
      ref = this.headerNav.children(".dropdown");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        dropdown = ref[i];
        dropdown = $(dropdown);
        leftPosition = dropdown.position().left;
        dropdownWidth = dropdown.find(".dropdown-nav").width();
        if ((navWidth - leftPosition) < dropdownWidth) {
          results.push(dropdown.not(".mega").find(".dropdown-nav").addClass("adjust-right"));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    HeaderView.prototype.positionMegaNav = function() {
      var containerHeight, heightCompensation, i, len, megaDropdownHeaderHeight, panel, ref, topOffset;
      heightCompensation = this.body.hasClass("minimalist") ? 2 : 1;
      topOffset = this.$(".mega.dropdown").outerHeight() - heightCompensation;
      megaDropdownHeaderHeight = this.megaDropdownHeader.outerHeight();
      containerHeight = 0;
      ref = this.megaDropdown.find("ul");
      for (i = 0, len = ref.length; i < len; i++) {
        panel = ref[i];
        panel = $(panel);
        if (panel.outerHeight() > containerHeight) {
          containerHeight = panel.outerHeight();
        }
      }
      this.megaDropdown.css({
        top: topOffset,
        height: megaDropdownHeaderHeight + containerHeight
      });
      return this.allPanels.css("height", containerHeight).find("ul").css("height", containerHeight);
    };

    HeaderView.prototype.determineNavAction = function(e) {
      var dropdownBreadcrumbs, dropdownTitles, secondaryBreadcrumb, target, targetIsSelected, targetList, targetPanel, targetText, tertiaryBreadcrumb;
      e.preventDefault();
      target = $(e.target).closest("li[data-expandable='true']");
      targetIsSelected = target.hasClass("active");
      targetPanel = target.data("list-level");
      targetText = target.find("a").text();
      targetList = target.data("parent");
      targetList = this.$("ul[data-child='" + targetList + "']");
      dropdownTitles = this.$(".dropdown-titles");
      dropdownBreadcrumbs = this.$(".dropdown-breadcrumbs");
      secondaryBreadcrumb = dropdownBreadcrumbs.children(".secondary");
      tertiaryBreadcrumb = dropdownBreadcrumbs.children(".tertiary");
      if (targetIsSelected) {
        target.removeClass("active");
        target.siblings().removeClass("disabled");
      } else {
        target.addClass("active").removeClass("disabled");
        target.siblings().removeClass("active").addClass("disabled");
      }
      if (targetPanel === 2 && !this.secondaryPanel.hasClass("active") && !this.tertiaryPanel.hasClass("active")) {
        this.toggleSecondaryPanel();
        this.displayTargetList(targetList, this.secondaryPanel);
        dropdownTitles.removeClass("visible");
        dropdownBreadcrumbs.addClass("visible");
        secondaryBreadcrumb.addClass("visible").find(".label").text(targetText);
      }
      if (targetPanel === 2 && !targetIsSelected && this.secondaryPanel.hasClass("active") && !this.tertiaryPanel.hasClass("active")) {
        this.displayTargetList(targetList, this.secondaryPanel);
        secondaryBreadcrumb.find(".label").text(targetText);
      }
      if (targetPanel === 2 && targetIsSelected && !this.tertiaryPanel.hasClass("active")) {
        this.toggleSecondaryPanel();
        dropdownTitles.addClass("visible");
        dropdownBreadcrumbs.removeClass("visible");
      }
      if (targetPanel === 3 && !this.tertiaryPanel.hasClass("active")) {
        this.toggleTertiaryPanel();
        this.displayTargetList(targetList, this.tertiaryPanel);
        tertiaryBreadcrumb.addClass("visible").find(".label").text(targetText);
      }
      if (targetPanel === 3 && !targetIsSelected && this.tertiaryPanel.hasClass("active")) {
        this.displayTargetList(targetList, this.tertiaryPanel);
        tertiaryBreadcrumb.find(".label").text(targetText);
      }
      if (targetPanel === 3 && targetIsSelected && this.tertiaryPanel.hasClass("active")) {
        this.toggleTertiaryPanel();
        tertiaryBreadcrumb.removeClass("visible");
      }
      if (targetPanel === 2 && targetIsSelected && this.tertiaryPanel.hasClass("active")) {
        this.closeAllPanels();
        dropdownTitles.addClass("visible");
        dropdownBreadcrumbs.removeClass("visible");
        tertiaryBreadcrumb.removeClass("visible");
      }
      if (targetPanel === 2 && !targetIsSelected && this.tertiaryPanel.hasClass("active")) {
        this.toggleTertiaryPanel();
        this.secondaryPanel.find("li").removeClass("active");
        this.displayTargetList(targetList, this.secondaryPanel);
        secondaryBreadcrumb.find(".label").text(targetText);
        return tertiaryBreadcrumb.removeClass("visible");
      }
    };

    HeaderView.prototype.displayTargetList = function(targetList, panel) {
      targetList.css("z-index", "1000");
      return panel.find("ul").not(targetList).css("z-index", "1");
    };

    HeaderView.prototype.toggleSecondaryPanel = function() {
      return this.secondaryPanel.toggleClass("active left-half");
    };

    HeaderView.prototype.toggleTertiaryPanel = function() {
      this.primaryPanel.toggleClass("width-half width-third");
      this.secondaryPanel.toggleClass("left-third width-third left-half width-half");
      return this.tertiaryPanel.toggleClass("active left-two-thirds width-half width-third");
    };

    HeaderView.prototype.closeAllPanels = function() {
      this.tertiaryPanel.toggleClass("active left-two-thirds width-half width-third");
      this.secondaryPanel.toggleClass("left-third width-third left-half width-half").one(this.transitionend, (function(_this) {
        return function() {
          _this.secondaryPanel.toggleClass("active left-half");
          return _this.secondaryPanel.find("li").removeClass("active");
        };
      })(this));
      return this.primaryPanel.toggleClass("width-half width-third");
    };

    HeaderView.prototype.toggleMobileNav = function(e) {
      var navItem, target;
      navItem = this.$(".mobile-nav-item");
      target = $(e.target).closest(navItem);
      if (navItem.hasClass("active") && !target.hasClass("active")) {
        target.toggleClass("active").removeClass("fade");
        navItem.not(target).addClass("fade").removeClass("active");
        return this.$(".mobile-nav-dropdown-container").add(".mobile-browse-container").toggleClass("active");
      } else {
        target.toggleClass("active");
        navItem.not(target).toggleClass("fade");
        if (target.hasClass("navigate")) {
          return this.$(".mobile-nav-dropdown-container").toggleClass("active");
        } else if (target.hasClass("browse")) {
          return this.$(".mobile-browse-container").toggleClass("active");
        }
      }
    };

    HeaderView.prototype.toggleMobileNavTier = function(e) {
      var target;
      e.preventDefault();
      target = $(e.target).parent();
      if (!target.hasClass("mega")) {
        target.find(".dropdown-nav").addClass("simple");
      }
      target.add(target.find(".arrow")).toggleClass("dropped");
      return target.find(".arrow").addClass("mobile").html("]");
    };

    HeaderView.prototype.toggleMobileMegaNavTier = function(e) {
      var target;
      e.preventDefault();
      target = $(e.target).closest("li[data-expandable='true']");
      target.add(target.children(".arrow")).toggleClass("dropped");
      return target.children(".arrow").addClass("mobile").html("]");
    };

    return HeaderView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.TwitterView = (function(superClass) {
    extend(TwitterView, superClass);

    function TwitterView() {
      return TwitterView.__super__.constructor.apply(this, arguments);
    }

    TwitterView.prototype.initialize = function() {
      return this.fetchTweets();
    };

    TwitterView.prototype.fetchTweets = function() {
      var config, tweetLimit;
      tweetLimit = 3;
      ;
      tweetLimit = parseInt("1");
      if (tweetLimit > 5) {
        tweetLimit = 5;
      }
      ;
      config = {
        "profile": {
          "screenName": ""
        },
        "maxTweets": tweetLimit,
        "enableLinks": true,
        "showUser": true,
        "showTime": true,
        "showRetweet": false,
        "customCallback": this.renderTweets,
        "showInteraction": false
      };
      return twitterFetcher.fetch(config);
    };

    TwitterView.prototype.renderTweets = function(tweets) {
      var i, len, tweet, tweetWrapper;
      tweetWrapper = $(".twitter-tweets");
      if (tweets.length) {
        for (i = 0, len = tweets.length; i < len; i++) {
          tweet = tweets[i];
          tweetWrapper.append("<div class='twitter-tweet'>" + tweet + "</div>");
          tweetWrapper.find(".user").remove();
        }
        return tweetWrapper.find(".timePosted").addClass("accent-text").appendTo();
      } else {
        $("#twitter").remove();
        return console.log("No tweets to display. Most probable cause is an incorrectly entered Widget ID.");
      }
    };

    return TwitterView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.InstagramView = (function(superClass) {
    extend(InstagramView, superClass);

    function InstagramView() {
      return InstagramView.__super__.constructor.apply(this, arguments);
    }

    InstagramView.prototype.initialize = function() {
      var url;
      this.photoContainer = this.$(".instagram-photos");
      url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + Theme.instagramAccessToken + "&count=8&callback=";
      return $.ajax({
        type: "GET",
        dataType: "jsonp",
        url: url,
        success: (function(_this) {
          return function(response) {
            var i, len, photo, ref, results;
            if (response.meta.code === 200) {
              ref = response.data;
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                photo = ref[i];
                results.push(_this.photoContainer.append("<a class='instagram-photo' target='_blank' href='" + photo.link + "'><img src='" + photo.images.low_resolution.url + "'/></a>"));
              }
              return results;
            } else {
              _this.$el.remove();
              return console.log("Instagram error: " + response.meta.error_message);
            }
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            _this.$el.remove();
            return console.log("Instagram error: " + response.meta.error_message);
          };
        })(this)
      });
    };

    return InstagramView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.HomeView = (function(superClass) {
    extend(HomeView, superClass);

    function HomeView() {
      return HomeView.__super__.constructor.apply(this, arguments);
    }

    HomeView.prototype.initialize = function() {
      ;
      ;
      ;
      new ProductListView({
        el: this.$("#featured-products")
      });
      ;
      if (this.$(".slideshow").length) {
        return this.setupSlideshow();
      }
    };

    HomeView.prototype.setupSlideshow = function() {
      var slideshow;
      slideshow = new Flickity(".slideshow", {
        autoPlay: "5000" * 1,
        pageDots: false,
        imagesLoaded: true,
        contain: true,
        cellSelector: ".slide",
        wrapAround: true
      });
      this.$(".slideshow").imagesLoaded((function(_this) {
        return function() {
          return $(".flickity-viewport").height($(".flickity-slider .slide").eq(0).height());
        };
      })(this));
      return slideshow.on("cellSelect", (function(_this) {
        return function() {
          return $(".flickity-viewport").height($(".flickity-slider .slide").eq(slideshow.selectedIndex).height());
        };
      })(this));
    };

    return HomeView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ProductListView = (function(superClass) {
    extend(ProductListView, superClass);

    function ProductListView() {
      return ProductListView.__super__.constructor.apply(this, arguments);
    }

    ProductListView.prototype.events = {
      "preload-images": "preloadImages"
    };

    ProductListView.prototype.initialize = function() {
      return this.preloadImages();
    };

    ProductListView.prototype.preloadImages = function(e, imageWrap) {
      var i, len, ref, results;
      ref = this.$(".product-item-image.is-loading");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        imageWrap = ref[i];
        results.push(this.showImage(imageWrap));
      }
      return results;
    };

    ProductListView.prototype.showImage = function(imageWrap) {
      var image;
      imageWrap = $(imageWrap);
      image = imageWrap.find("img");
      return imageWrap.imagesLoaded((function(_this) {
        return function() {
          if (image.height() < 100) {
            imageWrap.find(".product-details-overlay").addClass("landscape");
          }
          return imageWrap.removeClass("is-loading");
        };
      })(this));
    };

    return ProductListView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.CollectionView = (function(superClass) {
    extend(CollectionView, superClass);

    function CollectionView() {
      return CollectionView.__super__.constructor.apply(this, arguments);
    }

    CollectionView.prototype.events = {
      "click .click-to-load-button": "loadNewProducts",
      "change .collection-sort-filter select": "updateSortFilter",
      "change .collection-tag-filter select": "updateTagFilter"
    };

    CollectionView.prototype.initialize = function() {
      new ProductListView({
        el: this.$(".collection-content")
      });
      this.productList = this.$(".product-list");
      if (this.$("#content").hasClass("has-pagination") && (this.$("#content").hasClass("click-to-load") || this.$("#content").hasClass("infinite-scroll"))) {
        return this.initializeInfiniteScroll();
      }
    };

    CollectionView.prototype.initializeInfiniteScroll = function() {
      var behavior;
      this.clickToLoad = this.$(".click-to-load-button");
      this.currentProductsCount = this.$(".product-item").length;
      ;
      behavior = "twitter";
      ;
      return this.productList.infinitescroll({
        behavior: behavior,
        navSelector: "#pagination",
        nextSelector: "#pag-next a",
        itemSelector: ".product-item",
        loading: {
          finished: void 0,
          finishedMsg: "",
          img: "",
          msg: null,
          msgText: "",
          selector: null,
          speed: "fast",
          start: void 0,
          bufferPx: 200
        },
        errorCallback: (function(_this) {
          return function() {
            return _this.onProductsError();
          };
        })(this)
      }, (function(_this) {
        return function(newProducts) {
          return _this.onProductsLoad(newProducts);
        };
      })(this));
    };

    CollectionView.prototype.onProductsError = function() {
      return this.clickToLoad.removeClass("is-loading");
    };

    CollectionView.prototype.onProductsLoad = function(newProducts) {
      this.clickToLoad.removeClass("is-loading");
      this.productList.trigger("preload-images", [newProducts]);
      if (Theme.currencySwitcher) {
        $(".currency-switcher select").trigger("reset-currency");
      }
      this.currentProductsCount = this.currentProductsCount + $(newProducts).length;
      if (this.currentProductsCount === parseInt(this.productList.data("product-count"))) {
        this.clickToLoad.hide();
        return this.$(".collection-content").addClass("no-pagination");
      }
    };

    CollectionView.prototype.loadNewProducts = function(e) {
      this.productList.infinitescroll("retrieve");
      return this.$(e.target).addClass("is-loading");
    };

    CollectionView.prototype.updateSortFilter = function(e) {
      var Sorting, currentSearch, i, index, len, part, search, searchParts;
      Sorting = {};
      Sorting.sort_by = this.$(".collection-sort-filter select").val();
      if ($(e.target).closest(".collection-sorting").hasClass("vendor-collection")) {
        currentSearch = location.search;
        searchParts = currentSearch.split("&");
        for (index = i = 0, len = searchParts.length; i < len; index = ++i) {
          part = searchParts[index];
          if (part.indexOf("sort_by") !== -1) {
            searchParts.splice(index, 1);
          }
        }
        search = searchParts.join("&");
        return location.search = search + "&" + (jQuery.param(Sorting));
      } else {
        return location.search = jQuery.param(Sorting);
      }
    };

    CollectionView.prototype.updateTagFilter = function(e) {
      var collection, currentQuery, tag;
      collection = $(e.target).data("collection");
      tag = $(e.target).val();
      currentQuery = location.search;
      if (tag === "all") {
        return window.location.href = "/collections/" + collection + currentQuery;
      } else {
        return window.location.href = "/collections/" + collection + "/" + tag + currentQuery;
      }
    };

    return CollectionView;

  })(Backbone.View);

}).call(this);

(function() {
  ;

}).call(this);

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ProductView = (function(superClass) {
    extend(ProductView, superClass);

    function ProductView() {
      this.selectCallback = bind(this.selectCallback, this);
      return ProductView.__super__.constructor.apply(this, arguments);
    }

    ProductView.prototype.events = {
      "click #product-image-thumbnails img": "switchProductImage",
      "click #product-add input": "addToCart"
    };

    ProductView.prototype.initialize = function() {
      this.productId = this.$(".product-wrap").data("product-id");
      this.product = Theme.product;
      this.variants = this.product.variants;
      this.images = this.product.images;
      this.minimumPriceArea = this.$(".product-price-minimum");
      this.cacheImages();
      this.setupSelectors();
      this.addingToCart = false;
      ;
      new ProductListView({
        el: this.$("#related-products")
      });
      ;
      ;
      return Shopify.onError = (function(_this) {
        return function(XMLHttpRequest) {
          return _this.handleErrors(XMLHttpRequest);
        };
      })(this);
    };

    ProductView.prototype.switchCurrency = function(minimum, compare) {
      var attribute, i, len, ref;
      ref = this.minimumPriceArea[0].attributes;
      for (i = 0, len = ref.length; i < len; i++) {
        attribute = ref[i];
        if (attribute.name.indexOf("data-") > -1) {
          this.minimumPriceArea.attr(attribute.name, "");
        }
      }
      this.minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, Shopify.formatMoney(minimum, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      this.$(".product-price-compare").attr("data-currency-" + Theme.currency, Shopify.formatMoney(compare, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      return $(".currency-switcher").trigger("reset-currency");
    };

    ProductView.prototype.cacheImages = function() {
      return Shopify.Image.preload(this.images, "1024x1024");
    };

    ProductView.prototype.setupSelectors = function() {
      var i, len, optionSelectors, ref, variant;
      optionSelectors = new Shopify.OptionSelectors("product-variants", {
        product: this.product,
        onVariantSelected: this.selectCallback,
        enableHistoryState: true
      });
      optionSelectors.selectVariant(Theme.firstVariant);
      if (!(this.variants.length === 1 && (this.variants[0].title === "Default Title" || this.variants[0].title === "Default title"))) {
        this.$(".product-form").find(".product-options").addClass("visible");
        if (this.product.options.length === 1 && this.product.options[0] !== "Title") {
          this.$(".selector-wrapper").prepend("<label>" + this.product.options[0] + "</label>");
        }
      }
      ref = this.variants;
      for (i = 0, len = ref.length; i < len; i++) {
        variant = ref[i];
        if (variant.featured_image) {
          this.hasVariantImages = true;
          return;
        }
      }
    };

    ProductView.prototype.selectCallback = function(variant, selector) {
      var addToCartButton;
      addToCartButton = this.$("#product-add input");
      if (variant) {
        if (variant.available) {
          addToCartButton.val("Add").removeClass("disabled");
        } else {
          addToCartButton.val("Sold Out").addClass("disabled");
        }
        this.minimumPriceArea.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        this.$(".product-price-compare").remove();
        if (variant.compare_at_price > variant.price) {
          this.minimumPriceArea.after("<span class='product-price-compare accent-text money' />");
          this.$(".product-price-compare").html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat));
        }
        if (Theme.currencySwitcher) {
          this.switchCurrency(variant.price, variant.compare_at_price);
        }
        if (this.hasVariantImages) {
          if (variant.featured_image) {
            this.switchProductImage(null, variant.featured_image);
          } else {
            this.$(".product-main-image img").attr("src", this.product.featured_image);
          }
        }
      } else {
        addToCartButton.val("Unavailable").addClass("disabled");
      }
      return this.$(".product-message-wrapper").remove();
    };

    ProductView.prototype.switchProductImage = function(e, newImage) {
      var originalImage;
      originalImage = this.$("#product-image-showcase img");
      this.$("#product-image-thumbnails li").removeClass("active");
      if (e) {
        this.$(e.target).parent().addClass("active");
        originalImage.attr("src", this.$(e.target).data("high-res"));
      } else {
        this.$(".product-thumbnail[data-image-position='" + (newImage.position - 1) + "']").addClass("active");
        Shopify.Image.switchImage(newImage, originalImage[0]);
      }
      return originalImage.trigger("prepare-zoom");
    };

    ProductView.prototype.addToCart = function(e) {
      var button;
      e.preventDefault();
      ;
      if (!this.$(e.target).hasClass("disabled")) {
        this.$(e.target).addClass("disabled");
        this.$(".product-form").submit();
      }
      return ;
    };

    ProductView.prototype.updateCart = function() {
      return Shopify.getCart((function(_this) {
        return function(cart) {
          var cartCount, cartTotal;
          if (cart.item_count === 1) {
            cartCount = "1 item".replace("1", "" + cart.item_count);
          } else {
            cartCount = "0 items".replace("0", "" + cart.item_count);
          }
          $(".cart-item-count-wrap").text(cartCount);
          cartTotal = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
          $(".cart-amount-wrap").attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, cart.total_price).attr("data-currency", Theme.currency).text(cartTotal);
          return $(".currency-switcher").trigger("reset-currency");
        };
      })(this));
    };

    ProductView.prototype.handleErrors = function(error) {
      var max, message, responseJSON, target, variant, variantID;
      responseJSON = $.parseJSON(error.responseText);
      if (responseJSON.message === "Cart Error") {
        variantID = parseInt(this.$("#product-variants").val(), 10);
        target = (function() {
          var i, len, ref, results;
          ref = this.product.variants;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            variant = ref[i];
            if (variant.id === variantID) {
              results.push(variant);
            }
          }
          return results;
        }).call(this);
        max = target[0].inventory_quantity;
        message = "Unable to add more than {{ stock }} to your cart.".replace("{{ stock }}", max);
      } else {
        message = "We were unable to add this product to your cart. Please try again later. Contact us if you continue to have issues.";
      }
      return setTimeout((function(_this) {
        return function() {
          _this.$("#product-add-to-cart").append("<li class=\"product-message-wrapper\"><p class=\"product-message\">" + message + "</p></li>").addClass("error-message").removeClass("success-message");
          return _this.addingToCart = false;
        };
      })(this), 1000);
    };

    return ProductView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.RTEView = (function(superClass) {
    extend(RTEView, superClass);

    function RTEView() {
      return RTEView.__super__.constructor.apply(this, arguments);
    }

    RTEView.prototype.events = {
      "click .tabs li": "switchTabs"
    };

    RTEView.prototype.initialize = function() {
      this.setupTabs();
      return this.$el.fitVids();
    };

    RTEView.prototype.switchTabs = function(e) {
      var content, position, tab, tabContainer, tabContentContainer;
      tab = $(e.currentTarget);
      tabContainer = tab.parent();
      tabContentContainer = tabContainer.next();
      position = tab.index();
      content = tabContentContainer.find("> li").eq(position);
      tabContainer.find("> li").add(tabContentContainer.find("> li")).removeClass("active");
      return tab.add(content).addClass("active");
    };

    RTEView.prototype.setupTabs = function() {
      var tabs;
      tabs = this.$el.find(".tabs");
      return tabs.find("li:first").add(tabs.next().find("li:first")).addClass("active");
    };

    return RTEView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.SelectView = (function(superClass) {
    extend(SelectView, superClass);

    function SelectView() {
      return SelectView.__super__.constructor.apply(this, arguments);
    }

    SelectView.prototype.events = {
      "change": "updateSelectText"
    };

    SelectView.prototype.initialize = function() {
      if (!(this.$el.parent(".select-wrapper").length || this.$el.hasClass("product-variants"))) {
        this.$el.wrap("<div class='select-wrapper' />").parent().prepend("<span class='selected-text'></span>");
      }
      this.updateSelectText();
      if (!this.$el.hasClass("product-variants")) {
        this.$el.show();
      }
      return $("#address-country").on("change", (function(_this) {
        return function() {
          return _this.updateSelectText("province");
        };
      })(this));
    };

    SelectView.prototype.updateSelectText = function(select) {
      var newOption, target;
      if (select === "province") {
        target = $("#address-province");
      } else {
        target = this.$el;
      }
      newOption = target.find("option:selected").text() || target.find("option").eq(0).val();
      return target.siblings(".selected-text").text(newOption);
    };

    return SelectView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ShareView = (function(superClass) {
    extend(ShareView, superClass);

    function ShareView() {
      return ShareView.__super__.constructor.apply(this, arguments);
    }

    ShareView.prototype.events = {
      "click": "closeShare",
      "click .share-widget-toggle": "openShare"
    };

    ShareView.prototype.openShare = function(e) {
      var otherShareWidgets, targetShareWidget;
      targetShareWidget = this.$(e.target).closest(".article-meta-wrap");
      otherShareWidgets = $(".article-meta-wrap").not(targetShareWidget);
      targetShareWidget.addClass("active");
      return otherShareWidgets.removeClass("active");
    };

    ShareView.prototype.closeShare = function(e) {
      if (!(this.$(e.target).closest(".share-widget-toggle").length || this.$(e.target).closest(".share-widget").length)) {
        return $(".article-meta-wrap").removeClass("active");
      }
    };

    return ShareView;

  })(Backbone.View);

}).call(this);

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.QuickShopView = (function(superClass) {
    extend(QuickShopView, superClass);

    function QuickShopView() {
      this.selectCallback = bind(this.selectCallback, this);
      return QuickShopView.__super__.constructor.apply(this, arguments);
    }

    QuickShopView.prototype.events = {
      "click .product-item-quick-shop .available": "openQuickShop",
      "click .quick-shop-modal": "closeQuickShop",
      "click .quick-shop-add": "addToCart",
      "click .quick-shop-close": "closeQuickShop",
      "click .quick-shop-close-x": "closeQuickShopWithX"
    };

    QuickShopView.prototype.initialize = function() {
      this.quickShopModal = $(".quick-shop-modal");
      this.quickShopContainer = $(".quick-shop-container");
      this.quickShopConfirmation = this.$(".quick-shop-confirmation");
      this.minimumPriceArea = this.$(".quick-shop-price-minimum");
      this.addingToCart = false;
      this.transitionend = (function(transition) {
        var transEndEventNames;
        transEndEventNames = {
          "-webkit-transition": "webkitTransitionEnd",
          "-moz-transition": "transitionend",
          transition: "transitionend"
        };
        return transEndEventNames[transition];
      })(Modernizr.prefixed("transition"));
      return Shopify.onError = (function(_this) {
        return function(XMLHttpRequest) {
          return _this.handleErrors(XMLHttpRequest);
        };
      })(this);
    };

    QuickShopView.prototype.openQuickShop = function(e) {
      var firstVariant, i, len, ref, select, target;
      target = $(e.target);
      this.product = target.data("product-json");
      firstVariant = target.data("first-variant");
      this.setupProductDetails(this.product, firstVariant);
      this.setupSelectors(this.product, firstVariant);
      ref = this.$("select");
      for (i = 0, len = ref.length; i < len; i++) {
        select = ref[i];
        new SelectView({
          el: select
        });
      }
      this.quickShopModal.addClass("visible");
      setTimeout((function(_this) {
        return function() {
          _this.quickShopModal.addClass("active");
          return $(document.body).addClass("quick-shop-open");
        };
      })(this), 20);
      return this.positionQuickShop();
    };

    QuickShopView.prototype.closeQuickShopWithX = function(e, confirm, hasError) {
      if (e) {
        return this.quickShopContainer.empty();
      }
    };

    QuickShopView.prototype.closeQuickShop = function(e, confirm, hasError) {
      if (e) {
        if (!(this.$(e.target).closest(".quick-shop-container").length || this.$(e.target).closest(".product-item-quick-shop").length)) {
          this.quickShopModal.removeClass("active").one(this.transitionend, (function(_this) {
            return function() {
              _this.quickShopModal.removeClass("visible");
              _this.quickShopConfirmation.removeClass("active");
              _this.quickShopContainer.empty();
              $(document.body).removeClass("quick-shop-open");
              _this.addingToCart = false;
              if (hasError === "remove error") {
                return _this.$(".quick-shop-message").remove();
              }
            };
          })(this));
        }
      }
      if (confirm) {
        return this.quickShopContainer.removeClass("active").one(this.transitionend, (function(_this) {
          return function() {
            return _this.quickShopConfirmation.addClass("active");
          };
        })(this));
      }
    };

    QuickShopView.prototype.setupProductDetails = function(product, firstVariant) {
      var i, itemCompareAtPrice, itemPrice, len, ref, results, variant, variantPrice;
      itemPrice = Shopify.formatMoney(firstVariant.price, Theme.moneyFormat);
      itemCompareAtPrice = "";
      if (firstVariant.compare_at_price > firstVariant.price) {
        itemCompareAtPrice = Shopify.formatMoney(firstVariant.compare_at_price, Theme.moneyFormat);
      }
      this.quickShopContainer.append("<span class=\"quick-shop-close-x\">\n  <svg><use xlink:href=\"#icon-close\"/></svg>\n</span>\n<h2 class=\"quick-shop-title\">" + product.title + "</h2>\n<form class=\"product-form\" action=\"/cart/add\" method=\"post\" id=\"product-form-" + product.id + "\">\n    <div class=\"quick-shop-variants-container\">\n        <select class=\"product-variants\" name=\"id\" id=\"quick-shop-variants-" + product.id + "\"></select>\n    </div>\n    <div class=\"quick-shop-price-container accent-text\">\n        <span class=\"quick-shop-price-minimum money\">" + itemPrice + "</span>\n        <span class=\"quick-shop-price-compare money\">" + itemCompareAtPrice + "</span>\n    </div>\n    <input class=\"quick-shop-add action-btn accent-text\" type=\"submit\" value=\"Add\">\n</form>").data("product-json", product);
      ref = product.variants;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        variant = ref[i];
        variantPrice = Shopify.formatMoney(variant.price, Theme.moneyFormat);
        results.push(this.$(".product-variants").append("<option value='" + variant.id + "' data-sku='" + variant.sku + "'>" + variant.title + " - " + variantPrice + "</option>"));
      }
      return results;
    };

    QuickShopView.prototype.setupSelectors = function(product, firstVariant) {
      var i, index, len, option, optionSelectors, ref, results;
      optionSelectors = new Shopify.OptionSelectors("quick-shop-variants-" + product.id, {
        product: product,
        onVariantSelected: this.selectCallback,
        enableHistoryState: false
      });
      optionSelectors.selectVariant(firstVariant.id);
      if (product.variants.length === 1 && (product.variants[0].title === "Default Title" || product.variants[0].title === "Default title")) {
        this.quickShopContainer.find(".quick-shop-variants-container").addClass("no-options");
      } else if (product.options.length === 1) {
        this.$(".selector-wrapper").prepend("<label>" + product.options[0] + "</label>");
      }
      this.$(".selector-wrapper label").remove();
      ref = product.options;
      results = [];
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        option = ref[index];
        results.push(this.$(".selector-wrapper").eq(index).prepend("<label>" + product.options[index] + "</label>"));
      }
      return results;
    };

    QuickShopView.prototype.selectCallback = function(variant, selector) {
      var addToCartButton, minimumPriceArea, quickShopMessage;
      addToCartButton = this.$(".quick-shop-add");
      minimumPriceArea = this.$(".quick-shop-price-minimum");
      if (variant) {
        if (variant.available) {
          addToCartButton.val("Add").removeClass("disabled");
        } else {
          addToCartButton.val("Sold Out").addClass("disabled");
        }
        minimumPriceArea.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        this.$(".quick-shop-price-compare").remove();
        if (variant.compare_at_price > variant.price) {
          minimumPriceArea.after("<span class='quick-shop-price-compare money' />");
          this.$(".quick-shop-price-compare").html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat));
        }
        if (Theme.currencySwitcher) {
          this.switchCurrency(variant.price, variant.compare_at_price);
        }
      } else {
        addToCartButton.val("Unavailable").addClass("disabled");
      }
      quickShopMessage = this.$(".quick-shop-message");
      if (quickShopMessage.length) {
        return quickShopMessage.remove();
      }
    };

    QuickShopView.prototype.switchCurrency = function(minimum, compare) {
      var attribute, i, len, minimumPriceArea, ref;
      minimumPriceArea = this.$(".quick-shop-price-minimum");
      ref = minimumPriceArea[0].attributes;
      for (i = 0, len = ref.length; i < len; i++) {
        attribute = ref[i];
        if (attribute.name.indexOf("data-") > -1) {
          minimumPriceArea.attr(attribute.name, "");
        }
      }
      minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, Shopify.formatMoney(minimum, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      this.$(".quick-shop-price-compare").attr("data-currency-" + Theme.currency, Shopify.formatMoney(compare, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      return $(".currency-switcher").trigger("reset-currency");
    };

    QuickShopView.prototype.addToCart = function(e) {
      var button, product, productID;
      product = this.quickShopContainer.data("product-json");
      productID = product.id;
      if (this.addingToCart === true || $("#product-form-" + productID).serialize() === "") {
        return false;
      }
      e.preventDefault();
      button = this.$(".quick-shop-add");
      if (!button.children().hasClass("disabled")) {
        this.addingToCart = true;
        return Shopify.addItemFromForm("product-form-" + productID, (function(_this) {
          return function(item) {
            _this.updateCart(item);
            return _this.closeQuickShop(null, true);
          };
        })(this));
      }
    };

    QuickShopView.prototype.updateCart = function(item) {
      return Shopify.getCart((function(_this) {
        return function(cart) {
          var cartCount, newFormattedAmount;
          if (cart.item_count === 1) {
            cartCount = "1 item".replace("1", "" + cart.item_count);
          } else {
            cartCount = "0 items".replace("0", "" + cart.item_count);
          }
          newFormattedAmount = Shopify.formatMoney(cart.total_price, "");
          _this.$(".cart-item-count-wrap").text(cartCount);
          _this.$(".cart-amount-wrap").attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, cart.total_price).attr("data-currency", Theme.currency).html(newFormattedAmount);
          if (Theme.currencySwitcher) {
            return $(".currency-switcher").trigger("reset-currency");
          }
        };
      })(this));
    };

    QuickShopView.prototype.positionQuickShop = function() {
      var quickShopConfirmationHeight, quickShopHeight;
      quickShopHeight = this.quickShopContainer.outerHeight();
      this.quickShopContainer.css({
        marginTop: quickShopHeight / -2
      }).addClass("active");
      quickShopConfirmationHeight = this.quickShopConfirmation.outerHeight();
      return this.quickShopConfirmation.css({
        marginTop: quickShopConfirmationHeight / -2
      });
    };

    QuickShopView.prototype.handleErrors = function(error) {
      var max, message, target, variant, variantID;
      error = $.parseJSON(error.responseText);
      if (error.message === "Cart Error") {
        variantID = parseInt(this.$("#quick-shop-variants-" + this.product.id).val(), 10);
        target = (function() {
          var i, len, ref, results;
          ref = this.product.variants;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            variant = ref[i];
            if (variant.id === variantID) {
              results.push(variant);
            }
          }
          return results;
        }).call(this);
        max = target[0].inventory_quantity;
        message = "Unfortunately, we only have {{ stock }} in stock.".replace("{{ stock }}", max);
      } else {
        message = "We were unable to add this product to your cart. Please try again later. Contact us if you continue to have issues.";
      }
      this.quickShopContainer.append("<div class='quick-shop-message'>" + message + "</div>");
      return setTimeout((function(_this) {
        return function() {
          _this.closeQuickShop(null, null, "remove error");
          return _this.addingToCart = false;
        };
      })(this), 1000);
    };

    return QuickShopView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.CurrencyView = (function(superClass) {
    extend(CurrencyView, superClass);

    function CurrencyView() {
      return CurrencyView.__super__.constructor.apply(this, arguments);
    }

    CurrencyView.prototype.events = {
      "change [name=currencies]": "convertAll",
      "switch-currency": "switchCurrency",
      "reset-currency": "resetCurrency"
    };

    CurrencyView.prototype.initialize = function() {
      var cents, doubleMoney, i, j, len, len1, money, ref, ref1;
      Currency.format = Theme.currencySwitcherFormat;
      Currency.money_with_currency_format = {};
      Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
      Currency.money_format = {};
      Currency.money_format[Theme.currency] = Theme.moneyFormat;
      this.defaultCurrency = "USD";
      this.cookieCurrency = Currency.cookie.read();
      if (this.cookieCurrency) {
        this.$("[name=currencies]").val(this.cookieCurrency);
      }
      ref = $("span.money span.money");
      for (i = 0, len = ref.length; i < len; i++) {
        doubleMoney = ref[i];
        $(doubleMoney).parents("span.money").removeClass("money");
      }
      ref1 = $("span.money");
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        money = ref1[j];
        $(money).data("currency-" + Theme.currency, $(money).html());
        if (Currency.format === "money_with_currency_format") {
          cents = parseInt($(money).html().replace(/[^0-9]/g, ''), 10);
          $(money).html(Shopify.formatMoney(cents, Theme.moneyFormat));
        }
      }
      this.switchCurrency();
      return this.$(".selected-currency").text(Currency.currentCurrency);
    };

    CurrencyView.prototype.resetCurrency = function() {
      return Currency.convertAll(Theme.currency, this.$("[name=currencies]").val());
    };

    CurrencyView.prototype.switchCurrency = function() {
      if (this.cookieCurrency === null) {
        if (Theme.currency !== this.defaultCurrency) {
          return Currency.convertAll(Theme.currency, this.defaultCurrency);
        } else {
          return Currency.currentCurrency = this.defaultCurrency;
        }
      } else if (this.$("[name=currencies]").size() && this.$("[name=currencies] option[value=" + this.cookieCurrency + "]").size() === 0) {
        Currency.currentCurrency = Theme.currency;
        return Currency.cookie.write(Theme.currency);
      } else if (this.cookieCurrency === Theme.currency) {
        return Currency.currentCurrency = Theme.currency;
      } else {
        return Currency.convertAll(Theme.currency, this.cookieCurrency);
      }
    };

    CurrencyView.prototype.convertAll = function(e, variant, selector) {
      var newCurrency;
      newCurrency = $(e.target).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      this.$(".selected-currency").text(Currency.currentCurrency);
      return this.cookieCurrency = newCurrency;
    };

    return CurrencyView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.FooterView = (function(superClass) {
    extend(FooterView, superClass);

    function FooterView() {
      return FooterView.__super__.constructor.apply(this, arguments);
    }

    FooterView.prototype.initialize = function() {
      this.copyright = this.$(".footer-module.copyright");
      return $(window).on("resize", (function(_this) {
        return function() {
          if (document.documentElement.offsetWidth > 767 && _this.copyright.hasClass("block-module")) {
            return _this.positionCopyrightModule("large");
          } else if (document.documentElement.offsetWidth <= 767 && _this.copyright.hasClass("inline-module")) {
            return _this.positionCopyrightModule("medium");
          }
        };
      })(this)).trigger("resize");
    };

    FooterView.prototype.positionCopyrightModule = function(breakpoint) {
      var footerModuleWrapper;
      footerModuleWrapper = this.$(".footer-module-wrapper");
      this.copyright.toggleClass("inline-module block-module");
      if (breakpoint === "large") {
        return footerModuleWrapper.prepend(this.copyright);
      } else if (breakpoint === "medium") {
        return footerModuleWrapper.append(this.copyright);
      }
    };

    return FooterView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.PasswordView = (function(superClass) {
    extend(PasswordView, superClass);

    function PasswordView() {
      return PasswordView.__super__.constructor.apply(this, arguments);
    }

    PasswordView.prototype.events = {
      'click': 'closeModal',
      'click .admin-login-modal': 'openModal'
    };

    PasswordView.prototype.initialize = function() {
      this.modalWrapper = $('.password-page-modal-wrapper');
      this.modalContent = this.modalWrapper.find('.password-page-modal');
      this.openByDefault = this.modalWrapper.find('[data-open-modal]').length;
      if (this.openByDefault) {
        this.openModal();
      }
      return $(window).resize((function(_this) {
        return function() {
          return _this.positionModal();
        };
      })(this));
    };

    PasswordView.prototype.closeModal = function(e) {
      if (this.$(e.target).hasClass('visible')) {
        return this.modalWrapper.removeClass("visible").one("trend", (function(_this) {
          return function() {
            return _this.$el.removeClass("scroll-locked");
          };
        })(this));
      }
    };

    PasswordView.prototype.openModal = function() {
      this.$el.addClass("scroll-locked");
      this.positionModal();
      return this.modalWrapper.addClass("visible");
    };

    PasswordView.prototype.positionModal = function() {
      return this.modalContent.css({
        marginTop: -(this.modalContent.outerHeight() / 2),
        marginLeft: -(this.modalContent.outerWidth() / 2)
      });
    };

    return PasswordView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.GiftCardView = (function(superClass) {
    extend(GiftCardView, superClass);

    function GiftCardView() {
      return GiftCardView.__super__.constructor.apply(this, arguments);
    }

    GiftCardView.prototype.initialize = function() {
      return this.addQrCode();
    };

    GiftCardView.prototype.addQrCode = function() {
      var qrWrapper;
      qrWrapper = $('[data-qr-code]');
      return new QRCode(qrWrapper[0], {
        text: qrWrapper.data('qr-code'),
        width: 120,
        height: 120
      });
    };

    return GiftCardView;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  window.ThemeView = (function(superClass) {
    extend(ThemeView, superClass);

    function ThemeView() {
      return ThemeView.__super__.constructor.apply(this, arguments);
    }

    ThemeView.prototype.el = document.body;

    ThemeView.prototype.initialize = function() {
      var body;
      body = $(document.body);
      this.isHome = body.hasClass("template-index");
      this.isProduct = body.hasClass("template-product");
      this.isCollection = body.hasClass("template-collection");
      this.isSearch = body.hasClass("template-search");
      this.isPasswordPage = body.hasClass("template-password");
      this.isGiftCardPage = body.hasClass("gift-card-template");
      this.hasArticle = body.find(".article-meta-wrap");
      return this.isltIE10 = $("html").hasClass("lt-ie10");
    };

    ThemeView.prototype.render = function() {
      var i, j, len, len1, ref, ref1, rte, select;
      new HeaderView({
        el: $(".main-header")
      });
      new FooterView({
        el: $(".main-footer")
      });
      ref = $(".rte");
      for (i = 0, len = ref.length; i < len; i++) {
        rte = ref[i];
        new RTEView({
          el: rte
        });
      }
      if (Theme.currencySwitcher) {
        new CurrencyView({
          el: this.$(".currency-switcher")
        });
      }
      if (this.isHome) {
        new HomeView({
          el: this.$el
        });
      }
      if (this.isCollection) {
        new CollectionView({
          el: this.$el
        });
      }
      if (this.isProduct) {
        new ProductView({
          el: this.$el
        });
      }
      if (this.isSearch) {
        new ProductListView({
          el: $("#search-results")
        });
      }
      if (this.hasArticle) {
        new ShareView({
          el: this.$el
        });
      }
      if (this.isPasswordPage) {
        new PasswordView({
          el: this.$el
        });
      }
      if (this.isGiftCardPage) {
        new GiftCardView();
      }
      new QuickShopView({
        el: this.$el
      });
      ref1 = $("select");
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        select = ref1[j];
        new SelectView({
          el: select
        });
      }
      if (this.isltIE10) {
        return this.inputPlaceholderFix();
      }
    };

    ThemeView.prototype.inputPlaceholderFix = function() {
      var i, input, len, placeholders, text;
      placeholders = $("[placeholder]");
      for (i = 0, len = placeholders.length; i < len; i++) {
        input = placeholders[i];
        input = $(input);
        if (!(input.val().length > 0)) {
          text = input.attr("placeholder");
          input.attr("value", text);
          input.data("original-text", text);
        }
      }
      placeholders.focus(function() {
        input = $(this);
        if (input.val() === input.data("original-text")) {
          return input.val('');
        }
      });
      return placeholders.blur(function() {
        input = $(this);
        if (input.val().length === 0) {
          return input.val(input.data("original-text"));
        }
      });
    };

    return ThemeView;

  })(Backbone.View);

  $(function() {
    window.theme = new ThemeView();
    return theme.render();
  });

}).call(this);
    

/*! Magnific Popup - v1.0.0 - 2015-03-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isIE7=-1!==c.indexOf("MSIE 7."),b.isIE8=-1!==c.indexOf("MSIE 8."),b.isLowIE=b.isIE7||b.isIE8,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",b.ev=c.mainEl&&c.mainEl.length?c.mainEl.eq(0):d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.wrap.css(b.fixedContentPos?{overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}:{top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),b.currTemplate[d]=f?a(f):!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||2!==c.which&&!c.ctrlKey&&!c.metaKey){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(a,c){if(void 0===c||c===!1)return!0;if(e=a.split("_"),e.length>1){var d=b.find(p+"-"+e[0]);if(d.length>0){var f=e[1];"replaceWith"===f?d[0]!==c[0]&&d.replaceWith(c):"img"===f?d.is("img")?d.attr("src",c):d.replaceWith('<img src="'+c+'" class="'+d.attr("class")+'" />'):d.attr(e[1],c)}}else b.find(p+"-"+a).html(c)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&times;</button>',tClose:"Close (Esc)",tLoading:"Loading..."}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery",g=Boolean(a.fn.mfpFastClick);return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s),h=g?"mfpFastClick":"click";e[h](function(){b.prev()}),f[h](function(){b.next()}),b.isIE7&&(x("b",e[0],!1,!0),x("a",e[0],!1,!0),x("b",f[0],!1,!0),x("a",f[0],!1,!0)),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowLeft&&g&&b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),function(){var b=1e3,c="ontouchstart"in window,d=function(){v.off("touchmove"+f+" touchend"+f)},e="mfpFastClick",f="."+e;a.fn.mfpFastClick=function(e){return a(this).each(function(){var g,h=a(this);if(c){var i,j,k,l,m,n;h.on("touchstart"+f,function(a){l=!1,n=1,m=a.originalEvent?a.originalEvent.touches[0]:a.touches[0],j=m.clientX,k=m.clientY,v.on("touchmove"+f,function(a){m=a.originalEvent?a.originalEvent.touches:a.touches,n=m.length,m=m[0],(Math.abs(m.clientX-j)>10||Math.abs(m.clientY-k)>10)&&(l=!0,d())}).on("touchend"+f,function(a){d(),l||n>1||(g=!0,a.preventDefault(),clearTimeout(i),i=setTimeout(function(){g=!1},b),e())})})}h.on("click"+f,function(){g||e()})})},a.fn.destroyMfpFastClick=function(){a(this).off("touchstart"+f+" click"+f),c&&v.off("touchmove"+f+" touchend"+f)}}(),A()});

    
$('.all-finishes-open-popup').magnificPopup({
  type:'inline',
  midClick: true
});
